"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
let ConfirmInfo = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.imgmodel = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  opendialog(data) {
    if (data.datas.length > 0) {
      this.imgmodel = data.datas;
      this._info_dialog.show();
    } else {
      this.$emit("closeconfirm");
    }
  }
  openhtml(data) {
    return __async(this, null, function* () {
      window.open(data, "_blank");
    });
  }
  closeconfirm() {
    this._info_dialog.hide();
  }
  closeconfirmnow() {
    return __async(this, null, function* () {
      let _ids = [];
      this.imgmodel.forEach((data) => {
        _ids.push(data.id);
      });
      try {
        yield API.delete(`api://base.auth/api/v8/activity-popups`, {
          params: {
            "ids": _ids.join(",")
          }
        });
      } catch (error) {
      } finally {
        this.$emit("closeconfirm");
      }
    });
  }
};
__decorateClass([
  Ref("confirm-info-dialog")
], ConfirmInfo.prototype, "_info_dialog", 2);
ConfirmInfo = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], ConfirmInfo);
export {
  ConfirmInfo as default
};
